import React from "react";
import VendorComparisonGrid from "./vendor-comparison-grid";
import { DATADOG_COMPARISON_SECTIONS } from "./datadog-comparison-data";

type Props = {
  className?: string;
};

const DATADOG_BRAND = {
  name: "Datadog",
  logoSrc: "/images/datadog-bg-logo.svg",
  logoAlt: "Datadog Logo",
  headerLogoWidth: 119,
  headerLogoHeight: 42,
};

/** @deprecated Prefer VendorComparisonGrid with vendor data props */
const DatadogComparisonGrid: React.FC<Props> = ({ className = "" }) => (
  <VendorComparisonGrid
    className={className}
    sections={DATADOG_COMPARISON_SECTIONS}
    competitor={DATADOG_BRAND}
    
  />
);

export default DatadogComparisonGrid;
